export default __webpack_public_path__ + "static/media/skills.b3549ca6.png";